import { useFieldArray, useFormContext } from "react-hook-form";
import { IUser } from "../../../types/Auth/user";
import PermissionTable from "./PermissionTable";
import { salesPermissionValue } from "../../../utils/Permission/Sales";

const SalesPermissionTable = () => {
  const { control, watch } = useFormContext<IUser>();
  const { fields, replace } = useFieldArray({
    control,
    name: "sales_permission",
    keyName: "genId",
  });

  const watchFieldArray = watch("sales_permission");

  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...(watchFieldArray &&
        watchFieldArray.length > 0 &&
        watchFieldArray[index]),
    };
  });

  const resetArrayHandler = () => {
    replace(salesPermissionValue);
  };

  return (
    <PermissionTable
      module={"sales_permission"}
      controlledFields={controlledFields}
      resetArrayHandler={resetArrayHandler}
    />
  );
};

export default SalesPermissionTable;
